import React, { useEffect, useState } from 'react';
import Search from '../../icons/Search';

const OrderShipmentHeader = ({ filteredData, setFilteredData, Data }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const FilterData = () => {
    // Filter data based on search query if it's not empty
    let filtered = Data; // Initialize filtered data with all data

    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((directory) =>
        Object.values(directory).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    setFilteredData(filtered);
  };

  useEffect(() => {
    FilterData();
  }, [searchQuery, Data]);

  return (
    <div className='p-5 rounded-[10px] bg-[#fff]' style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}>
      <div className='flex justify-between items-center space-y-2 flex-wrap'>
        <div className='w-full md:w-auto flex items-center space-x-2'>
          <div className='w-full md:w-auto p-3 flex space-x-2 items-center rounded-[5px] border-2 border-blue'>
            <Search />
            <input
              placeholder="Search here"
              className="outline-none w-full"
              type="text"
              name=""
              id=""
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderShipmentHeader;